import React from "react";
import { FiCheckCircle, FiInfo, FiX, FiXCircle } from "react-icons/fi";
import { useCommerce } from "../../hooks/useCommerce";

const icons = {
  success: FiCheckCircle,
  error: FiXCircle,
  info: FiInfo,
};

const ToastRegion = () => {
  const { toast, hideToast } = useCommerce();
  if (!toast) return <div className="toast-region" aria-live="polite" />;

  const Icon = icons[toast.type] || FiInfo;
  return (
    <div className="toast-region" aria-live="polite" aria-atomic="true">
      <div className={`toast toast--${toast.type || "info"}`} role="status">
        <Icon aria-hidden="true" />
        <span>{toast.message}</span>
        <button type="button" onClick={hideToast} aria-label="Dismiss notification">
          <FiX aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default ToastRegion;
